<template>
  <transition
    tag="div"
    mode="out-in"
    class="relative"
    enter-active-class="transition-all transition-fastest ease-out-quad"
    leave-active-class="transition-all transition-faster ease-in-quad"
    enter-class="transform opacity-0 translate-x-2"
    enter-to-class="transform opacity-100 translate-x-0"
    leave-class="transform opacity-100 translate-x-0"
    leave-to-class="transform opacity-0 -translate-x-2"
  >
    <!-- Not selected state -->
    <div v-if="!selected.length && expert" key="empty-state">
      <div
        class="text-xs leading-none text-gray-500 font-medium tracking-tighter mb-1"
      >
        Rate
      </div>
      <div
        class="text-xl leading-none text-black font-medium tracking-tighter flex flex-row items-center"
      >
        {{ expert.basePrice ? `${expert.basePrice}€` : 'Free' }}
        <div class="text-base text-gray-600 font-medium tracking-tighter ml-1">
          / {{ expert.averageDuration }} min
        </div>
      </div>
    </div>
    <!-- selected -->
    <div
      v-if="selected.length"
      key="selected-state"
      class="flex flex-col justify-center md:items-end"
    >
      <p
        class="text-xl leading-none text-black font-medium tracking-tighter flex flex-row items-center"
      >
        {{
          calculatedPrice.amount ? `${calculatedPrice.total / 100}€` : 'Free'
        }}
      </p>
      <p class="text-base text-gray-600 font-medium tracking-tighter">
        {{ selectedFormatted }}
      </p>
    </div>
  </transition>
</template>

<script>
import { format } from 'date-fns';
import { calculateFees } from '~/helpers';

export default {
  props: {
    expert: {
      type: Object,
      required: false,
      default: null
    },
    selected: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  computed: {
    selectedFormatted() {
      if (this.selected.length === 1) {
        const date = new Date(this.selected[0].startsAt);
        return format(date, 'EE dd MMM - HH:mm');
      }
      return `${this.selected.length} Dates`;
    },

    calculatedPrice() {
      const baseAmount = this.selected.length * this.expert.basePrice;
      const price = calculateFees(baseAmount, 'EUR');
      return price;
    }
  }
};
</script>

<style lang="postcss" scoped></style>
